import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
// v0.19.30 (v01930 「添加学员」两步流程) — 建号**统一**走 `Api.create('users', …)` 这**一个**入口。
//   ⛔ 本文件改前是自己 `app.request` 拼 URL (`POST /ziiven/scheduler/users`);
//      现在第 1 步**不再建号**, 建号挪到第 2 步的 BindCardModal ⇒ 两边共用 `Api` 这一条路,
//      ⛔ 不许在 BindCardModal 里再抄一份 `app.request` 拼 URL 的建号代码。
import Api from '../utils/Api';
// v0.19.30 — 第 2 步 = **复用**「绑卡 modal」的「待建号模式」(`pendingStudent` 分支)。
//   ⇒ 本 modal 只负责第 1 步 (账号信息) + 查重 + 叠层打开第 2 步。
import BindCardModal from './BindCardModal';

/**
 * v0.19.30 — 就地错误条的样式**全部由 LESS 提供** (⛔ 不再用内联样式)。
 *
 * ⚠️ **为什么**: `less/forum.less` 里既有的 `.ZS-tf-hint` / `.ZS-tf-hint.danger`
 *   规则是**嵌在 `.ZS-BookingModal` 作用域里**的 (forum.less L12788 附近)
 *   ⇒ 在本 modal (`.ZS-AddStudentModal`) 里**一条都命不中** ⇒ 光加 class 会是灰字。
 * ⇒ v0.19.30 在 `less/forum.less` **末尾**追加了**作用域限定到本批两个 modal** 的
 *   同款声明 (`.ZS-AddStudentModal .ZS-tf-hint` / `.ZS-BindCardModal .ZS-tf-hint`)
 *   ⇒ 本文件**不写任何内联 style**。
 * ⚠️ class 名**照用** `.ZS-tf-hint danger` (**一字不改**) ⇒ 样式由 LESS 提供。
 */

/**
 * AddStudentModal — 添加学员 modal **第 1 步** (v0.5.8 拍板, 辉哥 9/25 10:26)
 *
 * v0.19.30 (v01930 两步流程) — 本 modal **只做「账号信息」这一步**:
 *   - 「卡种 (可选)」下拉**整块删除** ⇒ 卡种挪到第 2 步「绑定卡片」里选。
 *   - 主按钮 = 「下一步」: 点它只做**只读查重** (`GET /students/check-username`),
 *     **不建号**; 查重通过 ⇒ **叠层**打开第 2 步 (BindCardModal 的 `pendingStudent` 模式),
 *     账号在第 2 步点「绑定卡片」时**才真正创建**。
 *
 * ## Flarum 2.0 弹窗叠层的两条铁律 (v0.19.30 实测 core 源码)
 *   ① `app.modal.show(C, attrs)` 第三参默认 `false` ⇒ **整个弹窗栈被替换**
 *      (`ModalManagerState.show`: `modalList = [this.modal]`)
 *      ⇒ 打开第 2 步**必须**传第三参 `true` (`stackModal`)。
 *   ② ⛔⛔ **绝不**在 `app.modal.show()` **之前**调 `this.hide()`:
 *      `Modal.hide()` → `ModalManager.animateHide()` ⇒ 置 `modalClosing = true`,
 *      并在**当前栈顶**的 DOM 上挂 `transitionend` 监听; 紧接着 `show()` 把那个 DOM 移除
 *      ⇒ transitionend 永不触发 ⇒ `modalClosing` 永久停在 true
 *      ⇒ 之后**任何**弹窗的 hide() 都在 `if (modalClosing) return;` 处返回
 *      ⇒ 取消 / × / Esc 全部失效 ⇒ **全站弹窗从此关不掉**。
 *      (同款血泪警告见 `CardDetailModal.js:100-111` / `RefundApproveModal.js:313`)
 *      ⇒ 本文件**从不**在 `app.modal.show()` **之前**调 `hide()`。
 *      ⇒ 取消按钮用 `this.hide()` 是安全的: 它只在**第 1 步是栈顶**时才点得到 (见 content() 里的注释)。
 *
 * 模式: extends Modal (Flarum 2.0 ModalManager 单例, 自带 header / footer / backdrop)
 *
 * 设计图 (option-A-v0578-add-modal.html + option-A-v0578-desktop-modal.html):
 *   - mobile: 从底部弹起 sheet, 4 个字段垂直堆叠
 *   - desktop: 540px 居中, 2 列 grid (用户名/昵称 + 邮箱/手机号 + 校区只读 + 自动绑提示)
 *
 * 字段 (设计图):
 *   - 用户名* (必填, Flarum 标准规则)
 *   - 昵称 (选填, 用于 display_name)
 *   - 邮箱* (必填, 用于接收通知)
 *   - 手机号* (必填, 11 位中国手机号) — v0.5.8 新增字段 (迁移 migration 加 phone 列)
 *   - 所属校区 (只读显示"当前全局校区", 不让选 — 辉哥 10:14 拍板)
 *   - 自动绑提示卡 (绿色, 学员角色 group 自动绑定)
 *
 * API: 第 1 步**只读**查重 → GET /api/ziiven/scheduler/students/check-username
 *   建号 (POST /api/ziiven/scheduler/users) 在**第 2 步**发生 (见 BindCardModal)。
 *
 * 失败 / 成功后:
 *   - 查重不通过 → 就地错误条, 停在第 1 步
 *   - 第 2 步成功 → onDone → this.hide() + onCloseCb() + 父组件 reload
 */
export default class AddStudentModal extends Modal {
  oninit(vnode) {
    super.oninit(vnode);
    this.activeSchoolId = vnode.attrs.activeSchoolId;
    this.schools = vnode.attrs.schools || [];
    this.onCloseCb = vnode.attrs.onClose;
    this.saving = false;
    // v0.19.30 — 第 1 步的**就地**错误条 (用户名查重不通过) ⛔ 不用 alert()
    this.usernameError = '';
    // v0.19.30 补正 — 本流程**已经建出来**的用户名 (空 = 还没建过)。
    //   第 2 步建号成功后由 `onUserCreated` 回调写进来 ⇒ 第 1 步查重遇到「已占用」时,
    //   若占用者**正是本流程刚建的那个** ⇒ 放行到第 2 步继续绑卡
    //   (否则建卡失败 → 点「← 返回上一步」→ 第 1 步说「已占用」⇒ 卡死回不去第 2 步)。
    this.createdUsername = '';
    this.form = {
      username: '',
      nickname: '',
      email: '',
      phone: ''
    };
  }
  className() {
    // v0.5.8: 桌面 540px 居中, 移动端全屏 sheet (Flarum 原生 Modal 自带 .Modal--fullscreen-padded)
    return 'Modal--medium Modal--fullscreen-padded ZS-AddStudentModal';
  }

  /**
   * v0.19.30 — locale key 兜底。
   *
   * ⚠️ **为什么需要**: Flarum 的 translator 找不到 key 时**原样返回 key 本身**
   *   (core `Translator.tsx`: `fireDebugWarning('Missing translation for key')` → `return id`)
   *   ⇒ 本批新增的 key 由 Task B 补 locale, 在那之前页面上会出现
   *   「ziven-scheduler.forum.student-list.add-step1」这种**裸 key 字符串**。
   * ⇒ 兜底成中文; Task B 补上 key 之后**自动**走 trans() (无需改本文件)。
   *
   * @param {string} key      locale key
   * @param {string} fallback key 缺失时的兜底文案
   * @param {Object} [params] 插值参数 (Flarum 官方 `{placeholder}` 语法)
   */
  t(key, fallback, params) {
    // ⚠️ v0.19.30 补正 — ⛔ 第三个参数 `true` (extract) **必须给**:
    //   Flarum 的 `trans(id, params)` 在消息**含 `{placeholder}`** 时返回的是**数组**
    //   (core `Translator.tsx:136-143` → `formatter.rich()`), 不是字符串;
    //   拿它去拼字符串 ⇒ 数组按 "," 强制转换 ⇒ 文案里用户名两侧多出逗号。
    //   `trans(id, params, true)` ⇒ 返回**字符串** (core 的 `extractText` 用 '' 拼接, 无逗号)。
    const v = app.translator.trans(key, params || {}, true);
    return v === key ? fallback : v;
  }
  title() {
    return m("span", null, m("i", {
      className: "fas fa-user",
      style: "color:var(--zs-brand-3b82f6, #3b82f6);margin-right:8px;"
    }), app.translator.trans('ziven-scheduler.forum.student-list.add-title'));
  }

  // 找当前 active school name (只读显示)
  currentSchoolName() {
    const s = this.schools.find(x => String(x.id) === String(this.activeSchoolId));
    return s ? s.name : app.translator.trans('ziven-scheduler.forum.school-dropdown.select-school');
  }

  /**
   * v0.19.30 — 第 1 步主按钮: 「下一步」= **只查重**, **不建号**。
   *
   * ⚠️ **为什么第 1 步不建号**: 建号失败 (用户名/邮箱被占用) 是个**高频**错误,
   *   如果在第 1 步就建号, 员工填错用户名得**关掉整个弹窗**重填;
   *   拆成两步后, 建号挪到第 2 步, 失败了就地提示 + 「← 返回上一步修改用户名」
   *   ⇒ 第 1 步的数据**一个字没丢**。
   */
  async goNext() {
    if (this.saving) return;
    this.saving = true;
    this.usernameError = '';
    m.redraw();

    // 前端必填校验 (服务器再校验一次, 防直接 curl) —— 三条文案**一字不改**
    if (!this.form.username || this.form.username.trim() === '') {
      this.saving = false;
      m.redraw();
      alert(app.translator.trans('ziven-scheduler.lib.error-student-username-required'));
      return;
    }
    if (!this.form.email || this.form.email.trim() === '') {
      this.saving = false;
      m.redraw();
      alert(app.translator.trans('ziven-scheduler.lib.error-student-email-required'));
      return;
    }
    if (!this.form.phone || this.form.phone.trim() === '') {
      this.saving = false;
      m.redraw();
      alert(app.translator.trans('ziven-scheduler.lib.error-student-phone-required'));
      return;
    }

    // v0.19.30 — ① **只读**查重 (⛔ 不发 POST /users; 建号是第 2 步的事)
    //   ⚠️ 传 `{ errorHandler: () => {} }` ⇒ **抑制 Flarum 默认的全局红条**:
    //     Flarum 2.0 的 `app.request` 默认会弹一条全局红色 Alert (core `Application.tsx`
    //     的 `requestErrorCatch`) ⇒ 查重失败时页面上会同时出现「全局红条 + 我们的就地错误条」。
    //   ⚠️ core 契约: errorHandler 返回 `undefined` ⇒ **不弹**全局红条 (之后仍然 reject);
    //     返回 `false` ⇒ **回落默认** ⇒ **会弹** ⇒ ⛔ 绝不能返回 false ⇒ 这里写 `() => {}`。
    let check = null;
    try {
      check = await Api.checkUsername(this.form.username.trim(), {
        errorHandler: () => {}
      });
    } catch (e) {
      // ⚠️ 查重请求**失败** (抛错 / 返回空) ⇒ **放行**, 进第 2 步。
      //   理由: 查重是**体验优化**不是**准入闸**; 真重复由后端 POST /users 报,
      //   那时也能走第 2 步的「← 返回上一步修改用户名」。
      console.warn('[add-student] check-username failed, 继续进第 2 步', e);
      check = null;
    }
    if (check && check.available === false) {
      const curName = this.form.username.trim();
      // v0.19.30 补正 — 「已占用」但占用者**正是本流程上一步刚建的账号** ⇒ **放行**到第 2 步继续绑卡。
      //   (建卡失败 → 员工点「← 返回上一步」回到第 1 步 → 账号已建 → 查重说「已占用」→ 不放行就卡死)
      //   ⇒ 放行后第 2 步会再发一次 POST /users ⇒ 后端 `createOrReuse` **幂等复用** ⇒ 同一个 id
      //      ⇒ ⛔ 不会产生第二个用户。
      //   ⚠️ 只有**本流程刚建的**那个用户名才放行 ⇒ ⛔ 不会变成「用别人的账号绑卡」的口子。
      const isOurs = !!this.createdUsername && this.createdUsername === curName;
      if (!isOurs) {
        this.saving = false;
        // ⚠️ 这两句走 locale (`add-username-taken` / `add-username-format`),
        //    兜底文案与 locale 里的值**逐字一致** (Task B 已补上这两个 key)。
        this.usernameError = check.reason === 'format' ? this.t('ziven-scheduler.forum.student-list.add-username-format', '用户名格式不对（英文/数字/短横线/下划线，1-50 位）') : this.t('ziven-scheduler.forum.student-list.add-username-taken', '该用户名已被占用，请换一个');
        m.redraw();
        return; // ⛔ 停在第 1 步, 不进第 2 步
      }
    }

    // v0.19.30 — ② 进第 2 步 (⛔ **不建号**)
    const pendingStudent = {
      username: this.form.username.trim(),
      nickname: this.form.nickname.trim(),
      email: this.form.email.trim(),
      phone: this.form.phone.trim()
    };
    this.saving = false;

    // ⚠️ `setTimeout(…, 0)` **必须有**: Flarum 的 ModalManager 注释明说
    //   「从生命周期方法里调 `app.modal.show()` 需要它」(core ModalManagerState.show 的示例),
    //   仓库先例: `js/src/forum/utils/BookingModalHelper.js:84-86`。
    setTimeout(() => {
      app.modal.show(BindCardModal, {
        pendingStudent,
        schools: this.schools,
        activeSchoolId: this.activeSchoolId,
        // v0.19.30 补正 — 第 2 步**建号成功**后回传用户名 ⇒ 本流程记住「刚建出来的用户名」
        //   ⇒ 第 1 步查重遇到「已占用」时, 若占用者**正是本流程刚建的**就放行到第 2 步
        //      (否则建卡失败后点「← 返回上一步」会被卡死在第 1 步, 且留下孤儿账号)
        onUserCreated: info => {
          this.createdUsername = info && info.username ? String(info.username) : '';
        },
        onDone: () => {
          // 第 2 步建完号 **且** 建完卡 ⇒ 关掉第 1 步 + 通知父组件刷新
          // ⚠️ 这里**可以**用 this.hide(): 第 2 步**已经**用 app.modal.close() 退栈了,
          //   第 1 步此刻是栈顶且 DOM 还在 ⇒ transitionend 会照常触发 ⇒ 闩锁会复位。
          this.hide();
          if (this.onCloseCb) this.onCloseCb();
        }
      }, true); // ⛔⛔ 第三参 stackModal = true (默认 false ⇒ 整个弹窗栈被替换掉)
    }, 0);
  }

  // v0.5.8 — mobile + desktop 双布局 (CSS @media 控制显示)
  //   - mobile: 4 字段垂直堆叠 + 校区只读 + 自动绑提示 + 单个 +添加按钮
  //   - desktop: 2 列 grid 表单 + 同校区只读 + 自动绑提示 + 取消/添加按钮
  content() {
    return m("div", null, m("div", {
      className: "Modal-body"
    }, m("div", {
      className: "ZS-stepper"
    }, m("div", {
      className: "ZS-stepper-dot is-on"
    }, m("span", {
      className: "ZS-stepper-num"
    }, "1"), this.t('ziven-scheduler.forum.student-list.add-step1', '账号信息')), m("div", {
      className: "ZS-stepper-line"
    }), m("div", {
      className: "ZS-stepper-dot"
    }, m("span", {
      className: "ZS-stepper-num"
    }, "2"), this.t('ziven-scheduler.forum.student-list.add-step2', '绑定卡片'))), m("div", {
      className: "ZS-add-form-grid"
    }, m("div", {
      className: "ZS-form-group"
    }, m("div", {
      className: "ZS-form-label"
    }, app.translator.trans('ziven-scheduler.forum.student-list.add-username'), m("span", {
      className: "req"
    }, "*")), m("input", {
      className: "ZS-form-input",
      placeholder: app.translator.trans('ziven-scheduler.forum.student-list.add-username-placeholder'),
      value: this.form.username,
      oninput: e => {
        this.form.username = e.target.value;
      }
    }), this.usernameError && m("div", {
      className: "ZS-tf-hint danger"
    }, m("i", {
      className: "fas fa-triangle-exclamation",
      "aria-hidden": "true"
    }), m("span", null, this.usernameError))), m("div", {
      className: "ZS-form-group"
    }, m("div", {
      className: "ZS-form-label"
    }, app.translator.trans('ziven-scheduler.forum.student-list.add-nickname')), m("input", {
      className: "ZS-form-input",
      placeholder: app.translator.trans('ziven-scheduler.forum.student-list.add-nickname-placeholder'),
      value: this.form.nickname,
      oninput: e => {
        this.form.nickname = e.target.value;
      }
    })), m("div", {
      className: "ZS-form-group"
    }, m("div", {
      className: "ZS-form-label"
    }, app.translator.trans('ziven-scheduler.forum.student-list.add-email'), m("span", {
      className: "req"
    }, "*")), m("input", {
      className: "ZS-form-input",
      type: "email",
      placeholder: app.translator.trans('ziven-scheduler.forum.student-list.add-email-placeholder'),
      value: this.form.email,
      oninput: e => {
        this.form.email = e.target.value;
      }
    })), m("div", {
      className: "ZS-form-group"
    }, m("div", {
      className: "ZS-form-label"
    }, app.translator.trans('ziven-scheduler.forum.student-list.add-phone'), m("span", {
      className: "req"
    }, "*")), m("input", {
      className: "ZS-form-input",
      type: "tel",
      inputmode: "numeric",
      placeholder: app.translator.trans('ziven-scheduler.forum.student-list.add-phone-placeholder'),
      value: this.form.phone,
      oninput: e => {
        this.form.phone = e.target.value;
      }
    })), m("div", {
      className: "ZS-form-group ZS-form-group-full"
    }, m("div", {
      className: "ZS-form-label"
    }, app.translator.trans('ziven-scheduler.forum.student-list.add-school')), m("div", {
      className: "ZS-school-display"
    }, m("i", {
      className: "fas fa-house",
      "aria-hidden": "true"
    }), m("span", null, app.translator.trans('ziven-scheduler.forum.student-list.add-school-readonly'), ' ', m("strong", null, this.currentSchoolName())))), m("div", {
      className: "ZS-form-group ZS-form-group-full"
    }, m("div", {
      className: "ZS-auto-tag"
    }, m("div", {
      className: "ZS-auto-icon"
    }, m("i", {
      className: "fas fa-check",
      style: "color:var(--zs-success-10b981, #10b981);"
    })), m("div", null, m("div", {
      className: "ZS-auto-title"
    }, app.translator.trans('ziven-scheduler.forum.student-list.add-auto-bind')), m("div", {
      className: "ZS-auto-desc"
    }, app.translator.trans('ziven-scheduler.forum.student-list.add-auto-bind-desc'))))))), m("div", {
      className: "Modal-footer"
    }, m("button", {
      className: "Button",
      onclick: () => this.hide()
    }, app.translator.trans('ziven-scheduler.forum.student-list.add-cancel')), m("button", {
      className: "Button Button--primary",
      disabled: this.saving,
      onclick: () => this.goNext()
    }, this.saving ? app.translator.trans('ziven-scheduler.forum.student-list.add-nexting') : app.translator.trans('ziven-scheduler.forum.student-list.add-submit'))));
  }
}
flarum.reg.add('ziiven-ziven-scheduler', 'forum/modal/AddStudentModal', AddStudentModal);